import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';

const BlogLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      <div className="flex-grow">
        <div className="w-full px-4 py-12 relative">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogLayout; 